<!--
 * @Description: 
 * @Author: -898-
 * @Date: 2025-01-03 14:45:01
 * @LastEditTime: 2025-02-13 17:09:19
 * @LastEditors: -898-
-->
<template>
  <div>
    <ct-preview-image
      ref="previewPlugin"
      v-if="['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].indexOf(suffix) > -1"
      :image-info="JSON.stringify([file])"
    ></ct-preview-image>
  </div>
</template>

<script>
import CtPreviewImage from "@/components/CtPreviewImage";

export default {
  name: "Preview",
  components: { CtPreviewImage },
  data() {
    return {
      file: {},
      suffix: "",
    };
  },
  computed: {},
  created() {
    let filename = this.file.name;
    this.suffix = filename.substring(filename.lastIndexOf(".") + 1).toLowerCase();
  },
  mounted() {
    if (this.$refs.previewPlugin) {
      this.$refs.previewPlugin.setVisible(true);
    }
  },
  methods: {},
  watch: {
    suffix(suffix) {
      this.$refs.previewPlugin && this.$refs.previewPlugin.setVisible(true);
    },
  },
};
</script>

<style scoped></style>
